import React from 'react';

export const CubeDuotoneIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 62 62"
    fill="none"
    {...props}
  >
    <path
      d="M31 52V32.8889M48 20.9444L32.1498 9.80786C31.5941 9.41739 31.3162 9.22216 31 9.22216C30.6838 9.22216 30.4059 9.41739 29.8502 9.80786L14 20.9444V39.0165C14 39.5257 14 39.7803 14.1126 39.997C14.2252 40.2138 14.4336 40.3602 14.8502 40.6529L31 52L47.1498 40.6529C47.5664 40.3602 47.7748 40.2138 47.8874 39.997C48 39.7803 48 39.5257 48 39.0165V20.9444ZM31 32.8889L14 20.9444M31 32.8889L48 20.9444"
      stroke="#222222"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);
